import { create } from 'zustand';
import { combine } from 'zustand/middleware';
import { UserHttp } from '@/services';
import { SubsidyItem } from '@/services/user.service';

export interface CreditSlice {
  credit: number;
  subsidyCredit: number;
  loadingCredit: boolean;
  creditError: Error | null;
  subsidies: SubsidyItem[];
  fetchCredit(): Promise<void>;
  setCredit(data: CreditSlice): any;
}

export interface AppSlice extends CreditSlice {
}

const initialState = {
  credit: null,
  subsidyCredit: null,
  loadingCredit: false,
  creditError: null,
  subsidies: []
} as AppSlice;

const mutations = (
  setState: (...params: Partial<AppSlice>[]) => any,
  _getState: () => AppSlice
) => {
  return {
    fetchCredit: async () => {
      setState({ loadingCredit: true, creditError: null });
      try {
        const profile = (await UserHttp.fetchNurtureProfile()).payload;
        setState({
          loadingCredit: false,
          credit: profile.credit,
          subsidyCredit: profile.subsidyCredit,
          subsidies: profile?.subsidies ?? []
        });
      }
      catch (e) {
        setState({ creditError: e, credit: null, subsidyCredit: null });
      }
    },
    setCredit: (data: CreditSlice) => setState(data),
  };
};

const appStore = create(combine(initialState, mutations as any));
export default appStore;
